import { render, staticRenderFns } from "./personal-notice.vue?vue&type=template&id=60949bee"
import script from "./personal-notice.vue?vue&type=script&lang=js"
export * from "./personal-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60949bee')) {
      api.createRecord('60949bee', component.options)
    } else {
      api.reload('60949bee', component.options)
    }
    module.hot.accept("./personal-notice.vue?vue&type=template&id=60949bee", function () {
      api.rerender('60949bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/personalnotice-managment/personal-notice.vue"
export default component.exports